import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewListContainer } from './review-list.container';
import { ReviewListComponent } from './review-list.component';
import { PagingModule } from '@app/shared/ux/paging/paging.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { WucPictureModule } from '@inshared/website-ui-components';

@NgModule({
    imports: [
        CommonModule,
        PagingModule,
        LazyLoadImageModule,
        WucPictureModule,
    ],
    exports: [
        ReviewListContainer,
        ReviewListComponent,
    ],
    declarations: [
        ReviewListContainer,
        ReviewListComponent,
    ],
    providers: []
})
export class ReviewListModule {
}
